// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addressbook-shares__list[data-v-6aa9aea6]{margin-left:-8px;width:282px}`, "",{"version":3,"sources":["webpack://./src/components/AppNavigation/Settings/SettingsAddressbookShare.vue"],"names":[],"mappings":"AACA,2CACC,gBAAA,CACA,WAAA","sourcesContent":["\n.addressbook-shares__list {\n\tmargin-left: -8px;\n\twidth: 282px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
